import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowUpRight } from "lucide-react";

export const LatestHandoverPopup = ({ expo }) => {
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (!expo) return;
    if (sessionStorage.getItem("handover-popup-dismissed")) return;
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, [expo]);

  if (!expo || closed) return null;

  const dismiss = () => {
    setShow(false);
    setClosed(true);
    sessionStorage.setItem("handover-popup-dismissed", "1");
  };

  return (
    <div
      data-testid="latest-handover-popup"
      className={`fixed z-[60] left-4 bottom-4 w-[300px] max-w-[calc(100vw-2rem)] transition-all duration-500 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <div
        className="relative rounded-xl overflow-hidden shadow-2xl"
        style={{ background: "var(--surface)", border: "1px solid var(--line-strong)" }}
      >
        <button
          data-testid="handover-popup-close"
          onClick={dismiss}
          aria-label="Dismiss latest handover"
          className="absolute top-2 right-2 z-10 w-7 h-7 rounded-full flex items-center justify-center bg-black/50 text-white hover:bg-black/70 transition-colors"
        >
          <X size={14} />
        </button>

        <Link
          to={`/expo/${expo.slug}`}
          data-testid="handover-popup-link"
          onClick={dismiss}
          className="block group"
        >
          <div className="aspect-[16/10] overflow-hidden">
            <img
              src={expo.gallery?.[1] || expo.heroImage}
              alt={`${expo.name} stall handover`}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="p-4">
            <div className="flex items-center gap-2 mb-2">
              <span className="relative flex h-2 w-2">
                <span
                  className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75"
                  style={{ background: "var(--red)" }}
                />
                <span
                  className="relative inline-flex rounded-full h-2 w-2"
                  style={{ background: "var(--red)" }}
                />
              </span>
              <span className="font-mono text-[10px] tracking-[0.2em] text-[var(--red)]">
                JUST HANDED OVER{expo.handoverDate ? ` · ${expo.handoverDate.toUpperCase()}` : ""}
              </span>
            </div>
            <h4 className="font-display text-lg leading-tight mb-1">{expo.name}</h4>
            <p className="text-xs text-[var(--text-soft)] mb-3">
              {expo.city}, {expo.countryName} · Stall handover
            </p>
            <span className="inline-flex items-center gap-1 text-[var(--red)] text-xs font-medium">
              Watch the handover <ArrowUpRight size={13} />
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default LatestHandoverPopup;
